import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var giftBoxIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  fill: "none",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 4.966a11.187 11.187 0 0 0-1.329-1.795c-.883-.968-1.94-1.755-3.013-2.048-.548-.15-1.136-.18-1.706.005-.58.19-1.062.577-1.42 1.123-.68 1.035-.931 2.647-.784 4.815H1.917a.918.918 0 0 0-.917.92v4.29c0 .507.41.918.917.918h1.527v8.887c0 .507.41.919.917.919H19.64a.918.918 0 0 0 .917-.92v-8.885h1.527a.918.918 0 0 0 .917-.92v-4.29a.918.918 0 0 0-.917-.919h-1.83c.146-2.168-.105-3.78-.784-4.815-.36-.546-.84-.934-1.421-1.123-.57-.185-1.158-.155-1.706-.005-1.072.293-2.13 1.08-3.013 2.048A11.2 11.2 0 0 0 12 4.966Zm6.417 2.1c0-.022 0-.044.002-.065.149-2.09-.136-3.213-.481-3.738-.157-.24-.315-.34-.456-.386-.151-.049-.365-.06-.657.02-.609.166-1.384.682-2.143 1.515a9.463 9.463 0 0 0-1.695 2.654h5.43ZM9.319 4.412a9.46 9.46 0 0 1 1.694 2.654h-5.43c0-.022 0-.044-.002-.065-.149-2.09.136-3.213.481-3.738.157-.24.315-.34.456-.386.151-.049.365-.06.658.02.608.166 1.383.682 2.143 1.515ZM2.833 8.905v2.451h8.25V8.905h-8.25Zm10.084 0v2.451h8.249V8.905h-8.25Zm-1.834 4.29H5.278v7.966h5.805v-7.967Zm1.834 7.966v-7.967h5.805v7.967h-5.805Z",
  fill: "currentColor",
  fillRule: "evenodd"
}));

export { giftBoxIcon as default };
//# sourceMappingURL=giftBoxIcon.js.map
